import React, { useEffect, useState, useRef } from 'react'
import Confetti from 'react-dom-confetti'
import Icon from 'shared/ui/Icon'
import api from '../../utils/api'
import './BlogClaps.scss'

const confettiConfig = {
  angle: 90,
  spread: 45,
  startVelocity: 45,
  elementCount: 50,
  dragFriction: 0.1,
  duration: 3000,
  delay: 0,
  width: '10px',
  height: '10px',
  colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
}

function BlogClaps({ slug }) {
  const [loading, setLoading] = useState(true)
  const [claps, setClaps] = useState(0)
  const [queueClaps, setQueueClaps] = useState(0)
  const intervalRef = useRef(null)

  useEffect(() => {
    api.getBlogClaps(slug).then(({ claps }) => {
      setLoading(false)
      setClaps(claps)
    })
  }, [slug])

  useEffect(() => {
    if (queueClaps > 0) {
      const timeout = setTimeout(() => {
        api.addBlogClaps(slug, queueClaps).then(({ claps }) => {
          setClaps(claps)
          setQueueClaps(0)
        })
      }, 700)
      return () => clearTimeout(timeout)
    }
  }, [slug, queueClaps])

  function mouseDown() {
    intervalRef.current = setInterval(() => {
      setQueueClaps(queueClaps => {
        if (queueClaps === 100) {
          clearTimeout(intervalRef.current)
          return queueClaps
        } else {
          return queueClaps + 1
        }
      })
    }, 200)
    setQueueClaps(queueClaps => queueClaps + 1)
  }

  function mouseUp() {
    clearTimeout(intervalRef.current)
  }

  return (
    <div className="blog-claps">
      <button onMouseDown={mouseDown} onMouseUp={mouseUp}>
        <Confetti active={queueClaps > 0} config={confettiConfig} />
        <Icon name="clap" size={1.5} color="gray" />
      </button>
      <span>
        {loading ? 'Loading...' : `${(claps + queueClaps).toLocaleString()} claps`}
      </span>
    </div>
  )
}

export default BlogClaps
